import * as Yup from 'yup';

function schema() {
  return Yup.object().shape({
    phone: Yup.string().required('mobile number is required'),
  });
}

export default schema;
